import React, {useEffect, useState} from "react";
import {SubmitHandler, useForm} from "react-hook-form";
import {PubblicazioneWizard} from "@commons/mapping/PubblicazioneWizard";
import {DocumentoParams, MFilesDocParams} from "@commons/services/lavoratori/lavoratori.documenti.api";
import {useClassiDocsAltro, useMutationUploadAltro} from "@commons/services/lavoratori/lavoratori.documenti.queries";
import Select from "@components/wrapperComponents/Select";
import * as Validation from "@utilities/validationRules";
import InputEx from "@components/wrapperComponents/InputEx";
import {FileDropZone} from "../PVA/comps/FileDropZone";
import CheckboxEx from "@components/wrapperComponents/CheckboxEx";
import RadioInput from "@components/RadioInput";
import FormButtons from "@components/FormButtons";

interface UploadDocAltroProps {
    idDip: number,
    resource: PubblicazioneWizard,
    onCancel: () => void,
    params: DocumentoParams,
}

const UploadDocAltro: React.FC<UploadDocAltroProps> = ({idDip, resource, onCancel, params}) => {

    const form = useForm<PubblicazioneWizard>({mode: 'onChange', reValidateMode: 'onChange'});
    const {register, handleSubmit, formState: {errors}, watch, control, setValue} = form;

    const DocDisponibiliParams = {
        bygroup: true,
        mySearch: 'Documento+o+singola+comunicazione',
    } as MFilesDocParams;

    //PER SELECT DI +Documento NELLA SEZ. "ALTRI DOCUMENTI"
    const {data: classiDocs, error, isError} = useClassiDocsAltro(DocDisponibiliParams);
    if (isError) {
        onCancel();
        console.log('isError', isError);
        console.log('Error', JSON.stringify(error));
        console.log('classiDocs', JSON.stringify(classiDocs));
    }

    const [selectedFile, setSelectedFile] = useState<File[]>([]);

    const selVisibileAz = watch('visibileAzienda');
    const selVisibileLav = watch('visibileLavoratore');

    useEffect(() => {
        if (!selVisibileAz) {
            setValue("visibileLavoratore", false, {
                shouldValidate: true,
                shouldDirty: true
            })
            setValue("allegaDocANotifica", false, {
                shouldValidate: true,
                shouldDirty: true
            })
        }
        if (!selVisibileLav) {
            setValue("allegaDocANotifica", false, {
                shouldValidate: true,
                shouldDirty: true
            })
        }

    }, [selVisibileAz, selVisibileLav])

    const mutation = useMutationUploadAltro(idDip, params);
    const onSubmit: SubmitHandler<PubblicazioneWizard> = async (data) => {
        const formData = new FormData();

        formData.append("file", selectedFile[0]);
        //formData.append("idDoc", Number(data.idDoc).toString()); // ???
        formData.append("idClasse", Number(data.idClasse).toString());
        formData.append("descrizioneDoc", data.descrizioneDoc!);
        formData.append("docDeployType", 'IMMEDIATA'); //UNKNOWN, SCHEDULATA, IMMEDIATA;
        //formData.append("dataDeploy", null);
        //formData.append("oraDeploy", null);
        //formData.append("minutiDeploy", null);
        formData.append("allegaDocANotifica", 'false');
        formData.append("visibileAzienda", data.visibileAzienda ? 'true' : 'false');
        formData.append("visibileLavoratore", data.visibileLavoratore ? 'true' : 'false');


        mutation.mutate(formData);
    };

    return !classiDocs ? null : (<>
        <form onSubmit={handleSubmit(onSubmit)} className="mb-10">

            <div className="flexRowWrap">
                <Select label="Tipologia documenti" id="tipoDocumenti" name="idClasse"
                        divClass="w-3/6 pr-2" register={register} registerOptions={{valueAsNumber: true, ...Validation.required}} errors={errors}>
                    <option key="emptyKey" value={undefined}></option>
                    {classiDocs && classiDocs.map((item, index) => (
                        <option key={index} value={item.ID} className="text-gray-900 relative cursor-default select-none py-2 pl-3 pr-9">
                            {item.Name}
                        </option>)
                    )}
                </Select>
            </div>

            <div className="flexRowWrap">
                <div className="w-3/6 mt-2 pr-2">
                    <InputEx type="text" name="descrizioneDoc" label="Descrizione" register={register} registerOptions={{maxLength: 100, ...Validation.required}}
                             errors={errors}/>
                </div>
                <div className="w-3/6 mt-2 pl-2">
                    <FileDropZone droppedFiles={selectedFile} setDroppedFiles={setSelectedFile} accept="*"/>
                </div>
            </div>

            <div className="flexRowWrap mt-3">
                <div className="w-2/6 sm:pl-2">
                    <label className="mb-1 block font-medium">Opzioni</label>
                    <CheckboxEx name="visibileAzienda" label="Documento visibile all'azienda"
                                control={control}/>
                    <CheckboxEx name="visibileLavoratore" label="Documento visibile al lavoratore"
                                control={control} disabled={!selVisibileAz}/>
                    <CheckboxEx name="allegaDocANotifica" label="Allega il documento alla email di notifica"
                                control={control} disabled/>
                </div>
                <div className="w-1/6 sm:pl-2">
                    <label htmlFor="tipoPubblicazione" className="mb-1 block font-medium">Metodo pubblicazione</label>
                    <RadioInput className="!mb-0" label="Immediata" name="docDeployType" id="immediata"
                                register={register} registerOptions={Validation.required} value="IMMEDIATA" checked/>
                    <RadioInput className="!mb-0" label="Schedulata" name="docDeployType" id="schedulata"
                                register={register} registerOptions={Validation.required} value="SCHEDULATA" disabled/>
                    {errors && errors.docDeployType && <p className="text-rose-700">Specificare un metodo di pubblicazione!</p>}
                </div>
            </div>
            <FormButtons onCancel={onCancel} resource={resource} disableSave={selectedFile.length === 0 || selectedFile[0] === undefined}/>
        </form>
    </>)
}

export default UploadDocAltro;